import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box, Select, MenuItem, Typography, CircularProgress, TablePagination } from '@mui/material';

import { url } from 'src/apiUtils/apiPath';

import { appApi } from 'src/apiUtils/AppApi';
// components
import { useChart } from '../../../components/chart';



// ----------------------------------------------------------------------

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function AppWebsiteVisits({ title, subheader, chartLabels, chartData, ...other }) {
  const [chartBarData, setChartData] = useState()
  const [chartBarLabel, setChartBarLabel] = useState([])
  const [chartPlotData, setChartPlotData] = useState([])
  const [chartCount, setChartCount] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [page, setPage] = useState(1)
  const [count, setCount] = useState(5)
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = async (event) => {
    setRowsPerPage(event.target.value);
  };

  useEffect(() => {
    appApi(`${url.DASHBOARD_TODAY_BOOKING}`, "POST", {}, JSON.stringify({ limit: rowsPerPage, page })).then((result) => {
      if (result.status) {
        console.log(result.data)
        const chartPlot = [{
          name: 'Bookings',
          type: 'bar',
          fill: 'solid',
          data: result.data.data.map((e) => { return e.count })
        }]
        console.log('chartPlot', chartPlot)
        setChartPlotData(chartPlot);
        setChartBarLabel(result.data.data.map((e) => { return e._id }))
        // setChartCount(result.data.bookingCount)
        setChartCount(result.data.bookingCount)
      }
    })
  }, [])
  const chartOptions = useChart({
    plotOptions: {
      bar: {
        columnWidth: 85, borderRadius: 0.5, horizontal: false
      }
    },
    fill: { type: chartPlotData?.map((i) => i.fill) },
    labels: chartBarLabel,
    xaxis: { type: 'string' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)}`;
          }
          return y;
        },
      },
    },
  });


  return (
    <Card {...other} sx={{ height : 459 }}>
      <Box sx={{
        display: 'flex',
        justifyContent: "space-between",
        color: (theme) => theme.palette.primary.dark,
      }}>
        <CardHeader title={title} subheader={subheader} />
      </Box>


      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        {chartBarLabel && chartBarLabel.length > 0 ? <ReactApexChart type="line" key={count} series={chartPlotData} options={chartOptions} height={364} />
          : <Box display={"flex"} justifyContent={"center"} alignItems={'center'} sx={{ padding: 4, height: 364 }}>
            <Typography sx={{ color: 'red' }} variant={'h5'}>No Bookings Found</Typography>
          </Box>}
      </Box>
    </Card>
  );
}
